<template>
  <div id="Overview">
  	
  </div>
</template>

<script>
export default {
  name: 'Overview',
  data () {
    return {
      msg: 'Welcome to QdsPro'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Overview.vue